import { Link } from "react-router-dom";
import { Clock, Users, CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const WorkshopCard = ({ 
  title, 
  duration, 
  bestFor, 
  covers, 
  outcome,
  featured = false 
}) => {
  return (
    <div 
      className={`workshop-card h-full flex flex-col ${
        featured ? "border-[#008A90] border-2 shadow-md" : ""
      }`}
      data-testid={`workshop-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {featured && (
        <span className="inline-block bg-gradient-to-r from-[#008A90] to-[#007075] text-white text-xs font-semibold px-3 py-1.5 rounded-full mb-4 w-fit tracking-wide">
          Most Popular
        </span>
      )}
      
      <h3 className="text-xl md:text-2xl font-bold text-[#0A192F] mb-4 font-['Manrope']">
        {title}
      </h3>
      
      <div className="flex items-center gap-4 mb-5 text-[#475569]">
        <div className="flex items-center gap-2">
          <Clock size={16} className="text-[#008A90]" />
          <span className="text-[15px] font-medium">{duration}</span>
        </div>
      </div>
      
      <div className="mb-5">
        <div className="flex items-start gap-2.5">
          <Users size={16} className="text-[#008A90] mt-1 flex-shrink-0" />
          <div>
            <span className="font-semibold text-[#0A192F] text-[15px]">Best for:</span>
            <p className="text-body-sm mt-0.5">{bestFor}</p>
          </div>
        </div>
      </div>
      
      <div className="mb-5 flex-grow">
        <p className="font-semibold text-[#0A192F] mb-3 text-[15px]">What it covers:</p>
        <ul className="space-y-2">
          {covers.slice(0, 6).map((item, index) => (
            <li key={index} className="flex items-start gap-2 text-body-sm">
              <CheckCircle2 size={14} className="text-[#008A90] mt-0.5 flex-shrink-0" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
      
      <div className="mb-5 p-4 bg-[#F8FAFC] rounded-lg border border-[#E2E8F0]">
        <p className="font-semibold text-[#0A192F] mb-1 text-[15px]">Outcome:</p>
        <p className="text-body-sm">{outcome}</p>
      </div>
      
      <p className="text-sm text-[#64748B] italic mb-5">
        Workshop formats, availability, and pricing are available on enquiry.
      </p>
      
      <Link to="/contact" className="mt-auto">
        <Button 
          className="w-full bg-[#0A192F] hover:bg-[#112240] text-white font-semibold py-5 transition-all hover:-translate-y-0.5"
          data-testid={`enquire-btn-${title.toLowerCase().replace(/\s+/g, '-')}`}
        >
          Enquire About This Workshop
          <ArrowRight size={16} />
        </Button>
      </Link>
    </div>
  );
};

export default WorkshopCard;
